import { AttachMoney } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import PieChart from '../../../../../../../lib/designSystem/Charts/PieChart';

interface PaymentsDistributionChartProps {
  data: {
    byFund?: Array<{
      fundName: string;
      amount: number;
    }>;
  };
}

const PaymentsDistributionChart: React.FC<PaymentsDistributionChartProps> = ({
  data,
}) => {
  const pieData = useMemo(() => {
    if (!data?.byFund || data.byFund.length === 0) return [];

    return data.byFund.map((fund: { fundName: string; amount: number }) => ({
      id: fund.fundName,
      label: fund.fundName,
      value: fund.amount,
    }));
  }, [data?.byFund]);

  if (!data?.byFund || data.byFund.length === 0) {
    return (
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Distribución de Pagos
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Distribución porcentual del monto total de pagos por fondo
        </Typography>
        <Box
          sx={{
            height: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No hay datos disponibles para mostrar la distribución de pagos
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Box sx={{ mb: 3, height: '100%' }}>
      <PieChart
        data={pieData}
        title="Distribución de Pagos"
        icon={<AttachMoney sx={{ fontSize: 18, color: '#0F23DF' }} />}
        color="#0F23DF"
        formatAsMoney={true}
      />
    </Box>
  );
};

export default PaymentsDistributionChart;
